module.exports = __webpack_public_path__ + "img/JPM.99b91de6.png";